import React, { useEffect } from "react";

interface PaymentModaliCardProps {
  visible: boolean;
  onClose: (message: string) => void;
  domain: string;
  token: string;
  theme?: 'classic' | string;
}

const PaymentModaliCard: React.FC<PaymentModaliCardProps> = ({ visible, onClose, domain, token, theme = 'classic' }) => {
    useEffect(() => {
        // Load the payment modal script
        const script = document.createElement("script");
        script.src = `${domain}/js/payment-modal.js?token=${token}&theme=${theme}`;
        script.id = "ipg-io-js";
        script.async = true;
        document.body.appendChild(script);

        // Listen for messages from the payment modal
        const handleMessage = (event: MessageEvent) => {
            const message = event.data;
            console.log("PaymentModaliCard received:", event);

            // Handle cancel or close events
            if (
                message === 'ipg.user.cancel' ||
                message === 'ipg.user.close.on.success' ||
                message === 'ipg.user.close.on.error'
            ) {
                if (onClose) {
                    onClose(message); // Pass back the message if needed
                }
            }

            // You can also handle success, error, etc. here
            if (message === 'ipg.payment.success') {
                console.log("Payment successful!");
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            document.getElementById("ipg-io-js")?.remove();
            window.removeEventListener("message", handleMessage);
        };
    }, [domain, token, theme, onClose]);

    if (!visible) return null;

    return (
        <div id="ipg"></div>
    );
};

export default PaymentModaliCard;